export default "__VITE_ASSET__DFtFusjl__"